import { useEffect, useState } from "react";
import { getAlgorithmList } from "pages/dashboard/virtualGuard/service";
import { showToast } from "ui/components/common";
import { Button, Checkbox, Tabs } from "antd";

export default function AlgoTabSelection({ checkedAlgo, onCheckAlgo }) {
  const [algoTypes, setAlgoTypes] = useState([]);
  const [selectedAlgoType, setSelectedAlgoType] = useState(null);
  const [showupAlgos, setShowupAlgos] = useState([]);
  useEffect(() => {
    getAlgorithmList().then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to get algorithm list");
      } else {
        setSelectedAlgoType(data.data.data[0].name);
        setAlgoTypes(data.data.data);
      }
    });
  }, []);
  useEffect(() => {
    const algos =
      algoTypes.find((algoType) => algoType.name === selectedAlgoType)?.algos ||
      [];
    setShowupAlgos(algos);
  }, [selectedAlgoType]);
  return (
    <div className="algoTabSelection">
      <Tabs
        activeKey={selectedAlgoType}
        items={algoTypes.map((algoType) => ({
          label: algoType.displayShort,
          key: algoType.name,
        }))}
        onChange={setSelectedAlgoType}
        centered={true}
        size={"small"}
      />
      {/* <div>
        <Button
          type="link"
          style={{ paddingLeft: "0px" }}
          onClick={() => {
            let allChecked = true;
            showupAlgos.forEach((algo) => {
              const match = checkedAlgo.find((item) => item.name === algo.name);
              if (match === undefined) {
                allChecked = false;
              }
            });
            showupAlgos.forEach((algo) => {
              onCheckAlgo(algo, !allChecked);
            });
          }}
        >
          select all
        </Button>
      </div> */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          width: "100%",
        }}
      >
        {showupAlgos.map((item) => {
          const match = checkedAlgo.find((_item) => _item.name === item.name);
          return (
            <Checkbox
              key={item.key}
              checked={!!match}
              onChange={(e) => onCheckAlgo(item, e.target.checked)}
              style={{ marginTop: "8px" }}
            >
              {item.display}
            </Checkbox>
          );
        })}
      </div>
    </div>
  );
}
